import styled from 'styled-components';

export const FaqContainer = styled.div`
  width: 100%;
  height: 100px; 
  background-image: url(/bg-compre-agora.png);
  background-size: cover;
  background-position: center;
  padding: 40px 0;
  display: flex; 
  align-items: center; 
  justify-content: center; 
`;


export const FaqContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center; 
  text-align: center; 
`;

export const FaqTitle = styled.h1`
  font-size: 48px;
  color: #ffffff;
  font-weight: 700;
  margin: 0;
`;

export const FaqIntro = styled.p`
  font-size: 18px;
  color: #ffffff;
  margin-top: 15px;

`;

export const FaqSection = styled.section`
  padding: 60px 0;
  background-color: #ffffff;
`;


export const FaqItem = styled.div`
  margin-bottom: 20px;
`;

export const FaqQuestion = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  cursor: pointer;
  font-size: 21px;
  font-weight: 700;
  color: #02391E;
  border: 2px solid #02391E; 
  border-radius: 15px; 
  svg {
    color: #02391E;
    transition: transform 0.3s ease;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    font-size: 30px; 
  }
`;

export const FaqAnswer = styled.div`
  background-color: #f2eaeaff;
  padding: 12px;
  border-radius: 12px;
  font-size: 17px;
  color: #000000ff;
`;